import { z } from "zod";

/**
 * Live Support tier 1 — the client sends a message, the assistant answers.
 *
 * The client's message is the ONLY thing on the wire. It deliberately does not
 * carry the answer, the topic, or whether to escalate: those are decided
 * server-side from `matchSupportAnswer`, because a client that could name its
 * own answer could put words in Bednbody's mouth in a thread a hub manager
 * later reads as the company's own reply.
 */
export const sendSupportMessageSchema = z.object({
  threadId: z.string().uuid(),
  // 2000 matches what a person plausibly types in a support box. The column is
  // unconstrained text; the limit exists so one paste cannot fill the table.
  body: z.string().trim().min(1, "Write a message first.").max(2000),
});

export type SendSupportMessageInput = z.infer<typeof sendSupportMessageSchema>;
